import MemoryStorage from "./memory.storage";

let LocalStorage;

try {
    LocalStorage = localStorage;
} catch (e) {
    LocalStorage = new MemoryStorage();
}

export default LocalStorage;